/* v8 ignore start */
import {Collection} from "@/lib/core/collection";
import {LottieCompositionModel} from "@/lib/lottie/animation/lottieCompositionModel";
import {LottieAssetModel} from "@/lib/lottie/assets/lottieAssetModel";
import {TIntBoolean} from "@/lib/lottie/helpers/intBoolean";
import {LottieImageLayerModel} from "@/lib/lottie/layers/lottieImageLayerModel";
import {lottieLayerModelResolver, TLottieLayerModel} from "@/lib/lottie/layers/lottieLayerModelResolver";
import {LottiePrecompositionLayerModel} from "@/lib/lottie/layers/lottiePrecompositionLayerModel";
import {LottieTextLayerModel} from "@/lib/lottie/layers/lottieTextLayerModel";

// TODO: The class should also extend LottieAssetModel (double inheritance), currently the class is not used but it might be used in the future
export class LottiePrecompositionModel extends LottieCompositionModel<LottiePrecompositionModel.IJson> {
  public get id(): string {
    return this.json.id;
  }

  public get name(): Maybe<string> {
    return this.json.nm;
  }

  public get frameRate(): number {
    return this.json.fr;
  }

  public get layers(): Collection<TLottieLayerModel> {
    const {layers = []} = this.json;

    return new Collection(layers.map((layerJson) => lottieLayerModelResolver(layerJson)));
  }

  public get textLayers(): Collection<LottieTextLayerModel> {
    return this.selectLayersByType(LottieTextLayerModel);
  }

  public get preCompositionLayers() {
    return this.selectLayersByType(LottiePrecompositionLayerModel);
  }

  public selectLayersByType<T extends TLottieLayerModel>(type: new (...args: any[]) => T) {
    return this.layers.select((layerModel) => layerModel instanceof type) as Collection<T>;
  }

  public addLayer<T extends TLottieLayerModel>(newLayer: T): this {
    return this.update({
      layers: [...this.json.layers, newLayer.toObject()],
    });
  }

  public addLayerObject(newLayer: object): this {
    return this.update({
      layers: [...this.json.layers, newLayer as any],
    });
  }

  public updateLayers<T extends TLottieLayerModel>(predicate: (layerModel: T) => T): this {
    return this.update({
      layers: this.layers.map((layerModel) => predicate(layerModel as T).toObject()),
    });
  }

  public updateLayersByType<T extends TLottieLayerModel>(
    type: new (...args: any[]) => T,
    predicate: (layerModel: T) => T
  ): this {
    return this.update({
      layers: this.layers.map((layerModel) => {
        if (layerModel instanceof type) {
          return predicate(layerModel).toObject();
        } else {
          return layerModel.toObject();
        }
      }),
    });
  }

  public getImageLayerByRefId(refId: string): LottieImageLayerModel {
    return this.layers.select((layer) => layer instanceof LottieImageLayerModel && layer.refId === refId)
      .firstOrThrow as LottieImageLayerModel;
  }

  public get isBackgroundItem(): boolean {
    return Boolean(this.name?.includes("BACKGROUND"));
  }
}

export namespace LottiePrecompositionModel {
  export interface IJson extends LottieAssetModel.IJson, LottieCompositionModel.IJson {
    /**
     * Framerate in frames per second
     */
    fr: number;

    /**
     * Extra composition
     * @default 0
     */
    xt?: TIntBoolean;
  }
}
/* v8 ignore stop */
